import { Component, Input } from '@angular/core';

import { SortOrder } from '../sort-order.enum';

@Component({
  selector: 'cc-user-list-sorting-icon',
  templateUrl: './user-list-sorting-icon.component.html',
  styleUrls: ['./user-list-sorting-icon.component.scss'],
})
export class UserListSortingIconComponent {
  @Input() isActive: boolean;
  @Input() currentSortOrder: SortOrder;

  readonly sortOrder = SortOrder;
}
